import { crudService } from '../_services/';
import alerts from '../_components/alerts';

export const logFazendaSincAction = {
    getLogFazendaSinc,
    postSincronismoFinanceiro,
    postSincronismoInseminadores,
    postSincronismoZootecnico
};

function getLogFazendaSinc() {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'log/fazendas';
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeLogsList(response.data));
                alerts.clean();
            })
    };
}

function postSincronismoFinanceiro(linkNgrok, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = '/api/chamadasFinanceiro/sinc/';
        crudService.postNgrokUrl(linkNgrok + apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/relatorioLog');
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function postSincronismoZootecnico(linkNgrok, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = '/api/chamadas/sinc/';
        console.log('linkNgrok + apiEndpoint', linkNgrok + apiEndpoint)
        crudService.postNgrokUrl(linkNgrok + apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/relatorioLog');
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function postSincronismoInseminadores(linkNgrok, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = '/api/chamadasInseminadores/sinc/';
        crudService.postNgrokUrl(linkNgrok + apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/relatorioLog');
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

export function changeLogsList(logFazendaSinc) {
    return {
        type: "FETECHED_ALL_LOG_FAZENDA_SINC",
        logFazendaSinc: logFazendaSinc
    }
}